import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { Schedule } from "@mui/icons-material";

const formatDate = (value) => {
  if (!value) return null;
  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }
    return date.toLocaleDateString("en-ZA", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return value;
  }
};

const getChipColor = (status) => {
  switch ((status || "").toLowerCase()) {
    case "overdue":
      return "error";
    case "due":
      return "warning";
    case "pending":
      return "info";
    case "completed":
      return "success";
    default:
      return "default";
  }
};

/**
 * FollowUpMention
 * Displays a consistent badge indicating follow-up count and status.
 */
export const FollowUpMention = ({
  summary,
  onClick,
  size = "small",
  variant = "outlined",
}) => {
  if (!summary || !summary.count) {
    return null;
  }

  const label = summary.count === 1 ? "1 follow-up" : `${summary.count} follow-ups`;
  const nextDueFormatted = formatDate(summary.nextDueDate);
  const tooltipParts = [
    label,
    summary.nextStatus && nextDueFormatted
      ? `Next: ${summary.nextStatus} • ${nextDueFormatted}`
      : null,
    summary.latestStatus && !summary.nextStatus ? `Latest: ${summary.latestStatus}` : null,
  ].filter(Boolean);

  const chip = (
    <Chip
      icon={<Schedule fontSize="small" />}
      label={label}
      color={getChipColor(summary.nextStatus || summary.latestStatus)}
      variant={variant}
      size={size}
      onClick={onClick}
      sx={{ textTransform: "none" }}
    />
  );

  if (tooltipParts.length === 0) {
    return chip;
  }

  return (
    <Tooltip title={tooltipParts.join(" • ")}>
      <span>{chip}</span>
    </Tooltip>
  );
};

export default FollowUpMention;

